import { Injectable, signal } from '@angular/core';

/**
 * Holds dev-only state for toggling credit API mocks.
 * Toggled from dev menu; read by CreditMockInterceptor.
 * No dependency on credit or credit-setup modules.
 */
@Injectable({
  providedIn: 'root',
})
export class CreditMockStateService {
  readonly useCreditMock = signal<boolean>(false);

  toggleCreditMock(): void {
    this.useCreditMock.update((v) => !v);
  }
}
